/*
* @Description: 协议SAP字段默认配置管理
* @Author: gzw
* @Date: 2025-08-06
*/
<template>
  <div class="sap-field-config-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" :model="searchForm" ref="searchForm" inline
             label-width="80px">
      <el-form-item label="业务模式" prop="businessModel">
        <el-input v-model="searchForm.businessModel" placeholder="请输入业务模式"></el-input>
      </el-form-item>
      <el-form-item label="体系名称" prop="systemName">
        <el-input v-model="searchForm.systemName" placeholder="请输入体系名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
        <el-button type="primary" @click="handleAdd" v-permission="'0011902'">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="configData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="systemName"
        label="体系名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="businessModel"
        label="业务模式"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="deptName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="SAP订单类型"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ formatSapOrderType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        label="SAP项目类别"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ formatSapProductType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        label="SAP客户订单类型"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ formatSapBusinessType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sapSaleOrg"
        label="SAP销售组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-permission="'0011903'">
            编辑
          </el-button>
          <el-button size="mini" @click="handleDel(scope.$index, scope.row)" type="danger" v-permission="'0011904'">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNum"
      background>
    </el-pagination>
    <add-or-edit-dialog :show.sync="addOrEditDialogShow" :formData="addOrEdit"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'sapFieldConfigManager',
  components: { AddOrEditDialog },
  data () {
    return {
      searchForm: {
        systemName: '',
        businessModel: ''
      },
      addOrEdit: {},
      addOrEditDialogShow: false
    }
  },
  computed: {
    ...mapState({
      configData: state => state.sapFieldConfigManager.list,
      listState: state => state.sapFieldConfigManager.listState
    })
  },
  mounted () {
    const params = {
      ...this.searchForm,
      pageNum: 1,
      pageSize: 10
    }
    this.getSapFieldConfigList(params)
  },
  methods: {
    ...mapActions(['getSapFieldConfigList', 'addOrEditSapFieldConfig', 'delSapFieldConfig']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        ...this.searchForm,
        pageNum: 1
      }
      this.getSapFieldConfigList(params)
    },
    reset () {
      this.$refs['searchForm'].resetFields()
      this.handleSearch()
    },
    handleAdd () {
      this.addOrEdit = {}
      this.addOrEditDialogShow = true
    },
    handleEdit (index, row) {
      let obj = {
        ...row
      }
      this.addOrEdit = obj
      this.addOrEditDialogShow = true
    },
    handleDel (index, row) {
      this.$confirm('是否确认删除', '删除提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delSapFieldConfig({ id: row.id }).then(() => {
          this.getSapFieldConfigList({ pageNum: 1 })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        // 取消删除
      })
    },
    handleSizeChange (val) {
      this.getSapFieldConfigList({ pageNum: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getSapFieldConfigList({ pageNum: val })
    },
    // 格式化SAP订单类型显示
    formatSapOrderType (row) {
      if (row.sapOrderType && row.sapOrderTypeName) {
        return `${row.sapOrderType}(${row.sapOrderTypeName})`
      }
      return row.sapOrderTypeName || ''
    },
    // 格式化SAP项目类别显示
    formatSapProductType (row) {
      if (row.sapProductType && row.sapProductTypeName) {
        return `${row.sapProductType}(${row.sapProductTypeName})`
      }
      return row.sapProductTypeName || ''
    },
    // 格式化SAP客户订单类型显示
    formatSapBusinessType (row) {
      if (row.sapBusinessType && row.sapBusinessTypeName) {
        return `${row.sapBusinessType}(${row.sapBusinessTypeName})`
      }
      return row.sapBusinessTypeName || ''
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
